import { render, staticRenderFns } from "./PersonalDetailsDP.vue?vue&type=template&id=c8c39df8"
import script from "./PersonalDetailsDP.vue?vue&type=script&lang=js"
export * from "./PersonalDetailsDP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports